import { defaultInitialState, defaultApiState, loadingState, updatedState, getErrorState } from '../utils';
import { FETCH_PILL_OPTIONS_STUB, FETCH_PILL_OPTIONS_STUB_DONE, FETCH_PILL_OPTIONS_STUB_ERR, SET_PILL_OPTIONS_STUB, FETCH_PILL_OPTIONS_NAME, FETCH_PILL_OPTIONS_NAME_DONE, FETCH_PILL_OPTIONS_NAME_ERR, SET_PILL_OPTIONS_NAME, FETCH_PILL_OPTIONS_FORM, FETCH_PILL_OPTIONS_FORM_DONE, FETCH_PILL_OPTIONS_FORM_ERR, SET_PILL_OPTIONS_FORM, FETCH_PILL_OPTIONS_STRENGTH, FETCH_PILL_OPTIONS_STRENGTH_DONE, FETCH_PILL_OPTIONS_STRENGTH_ERR, SET_PILL_OPTIONS_STRENGTH, RESET_PILL_OPTIONS, SET_PILL_OPTIONS_TYPE, SET_PILL_OPTIONS_SOURCE, SET_PILL_OPTIONS_EXPIRES, SET_PILL_OPTIONS_SCHEDULES, SET_PILL_OPTIONS_SEARCH_STRING, SET_PILL_OPTIONS_STORED_IN_HERO } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: {
        source: null,
        search_string: '',
        stub: '',
        stubOptions: [],
        is_generic: false,
        name: '',
        nameOptions: {
            branded: [],
            generic: []
        },
        form: '',
        formOptions: null,
        strength: '',
        strengthOptions: null,
        gpi: '',
        medication_type: '',
        stored_in_hero: false
    } });
// TODO: split into two reducers
/* eslint-disable complexity*/
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PILL_OPTIONS_SOURCE:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data) }), defaultApiState);
        case SET_PILL_OPTIONS_SEARCH_STRING:
            // changes on every keystroke, so don't reset anything but search_string
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data) });
        case FETCH_PILL_OPTIONS_STUB:
            return Object.assign(Object.assign({}, state), loadingState);
        case FETCH_PILL_OPTIONS_STUB_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { stubOptions: action.data }) }), updatedState);
        case FETCH_PILL_OPTIONS_STUB_ERR: {
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        }
        case SET_PILL_OPTIONS_STUB:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { stub: action.data.stub }) }), defaultApiState);
        case FETCH_PILL_OPTIONS_NAME:
            return Object.assign(Object.assign({}, state), loadingState);
        case FETCH_PILL_OPTIONS_NAME_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { nameOptions: action.data }) }), updatedState);
        case FETCH_PILL_OPTIONS_NAME_ERR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case SET_PILL_OPTIONS_NAME:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data) }), defaultApiState);
        case FETCH_PILL_OPTIONS_FORM:
            return Object.assign(Object.assign({}, state), loadingState);
        case FETCH_PILL_OPTIONS_FORM_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { formOptions: action.data }) }), updatedState);
        case FETCH_PILL_OPTIONS_FORM_ERR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case SET_PILL_OPTIONS_FORM:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { form: action.data.form }) }), defaultApiState);
        case FETCH_PILL_OPTIONS_STRENGTH:
            return Object.assign(Object.assign({}, state), loadingState);
        case FETCH_PILL_OPTIONS_STRENGTH_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { strengthOptions: action.data }) }), updatedState);
        case FETCH_PILL_OPTIONS_STRENGTH_ERR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case SET_PILL_OPTIONS_STRENGTH:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data) }), defaultApiState);
        case SET_PILL_OPTIONS_TYPE:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data) }), defaultApiState);
        case SET_PILL_OPTIONS_EXPIRES:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data) }), defaultApiState);
        case SET_PILL_OPTIONS_SCHEDULES:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data) }), defaultApiState);
        case SET_PILL_OPTIONS_STORED_IN_HERO:
            return Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data) }), defaultApiState);
        case RESET_PILL_OPTIONS:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map